import { Input } from "../../../../form-inputs/inputs";
import React from "react";
import { useSoftValidation } from "../../../../../shared/hooks/use-soft-validation";
import { Tooltip } from "../../../../tooltip/tooltip";
import classnames from "classnames";

const stringPattern = "^[-+<>]?[0-9]*\\.?[0-9]+$";

export const Calorie = ({ updateField, calorieInfo, index }) => {
    const { servingText, calories, caloriesFromFat } = calorieInfo;
    const { enableWarning, displayWarning, tooltip, toggleWarning } = useSoftValidation();

    const handleValueUpdate = (key, value) => {
        if (displayWarning && enableWarning) {
            toggleWarning(false);
        }

        updateField("calorie", { servingText, calories: value, caloriesFromFat }, index);
    };

    return (
        <div className="column">
            <div className="input-group -stacked">
                <Input
                    id={`servingText_${index}`}
                    name="name"
                    label="Serving Text"
                    value={servingText}
                    updateOnChange={(key, value) => updateField("calorie", { servingText: value, calories, caloriesFromFat }, index)}
                />
                <p className="m-b-4">Calories:</p>
                <Tooltip
                    asWarning
                    text={displayWarning ? tooltip : undefined}
                    classes="m-r-4"
                    position="top"
                >
                    <Input
                        className={classnames({ "-warning": displayWarning })}
                        id={`calories_${index}`}
                        name="calories"
                        value={calories}
                        updateOnChange={handleValueUpdate}
                        pattern={stringPattern}
                    />
                </Tooltip>
                {caloriesFromFat !== null && (
                    <Input
                        name={`caloriesFromFat`}
                        label="Calories from Fat"
                        defaultValue={caloriesFromFat}
                        updateOnChange={(key, value) => updateField("calorie", { servingText, calories, caloriesFromFat: value }, index)}
                        pattern={stringPattern}
                    />
                )}
            </div>
        </div>
    );
};
